import React, { Component } from "react";
import SwipperBanner from "./components/SwipperBanner.js";
import TrendingJobs from "./components/TrendingJobs.js";
import TabSlider from "./components/TabSlider.js";
import ProgramsOffer from "./components/ProgramsOffer.js";
import CourseraCard from "./components/CourseraCard.js";
import VideoSlider from "./components/VideoSlider.js";
import FeaturedJobs from "./components/FeaturedJobs.js";
import EmployeeStory from "./components/EmployeeStory.js";
import FooterSection from "./components/FooterSection.js";
import WhatsNews from "./components/WhatsNews.js";
import MapSection from "./components/MapSection.js";
import KnowUsMore from "./components/KnowUsMore.js";
import fullPageBanner from "./img/fullbanner1.png";
import fullPageBanner2 from "./img/fullbanner4.png";
import chatbot from "./img/chat-bot.svg";
import "../css/Index.scss";
import Token from "api/Auth/auth";
import store from "store.js";
import { setMgToken, setHcToken, setLoader } from "store/Auth";
import { connect } from "react-redux";
import {
  getBillboardAction,
  getFeaturedJobAction,
  groupsAction,
  getCheckITVAction,
  getProgrammingAction,
  getHomeBannerAction,
  getknowUsMoreAction,
  getTeamiciciAction,
  getMoreJobsOnScrollAction,
  getGroupRelatedJobIdAction,
} from "store/Home";
import { groups } from "store/Home.js";
import { Link } from "react-router-dom";
import { GetAllStoriesAction } from "store/Story";
import { GetAllCourseAction } from "store/Ilearn";
class home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBillBoardLoaded: 0,
      homebanner1: "",
      homebanner2: "",
    };
  }
  async componentDidMount() {
    try {
      this.props.setLoader(true);
      let HcToken = await Token.getToken();
      store.dispatch(setHcToken(HcToken));
      let MgToken = await Token.getTokenMagitt();
      store.dispatch(setMgToken(MgToken));
      let response = this.props.getBillboardAction();
      let responseJob = this.props.getFeaturedJobAction();
      let responseGroup = this.props.groupsAction();
      let responseHomeBanner = this.props.getHomeBannerAction();
      let responseCheckItv = this.props.getCheckITVAction();
      let responseProgram = this.props.getProgrammingAction();
      let responseKnowUsMore = this.props.getknowUsMoreAction();
      let teamiciciResponse = this.props.getTeamiciciAction();
      let Stories = this.props.GetAllstories();
      let Courses = this.props.getAllCourses();
      let GroupRelatedJOB = this.props.getGroupRelatedJobIdAction(20995);

      let payload = {
        From: 1,
        PageNo: 0,
        limit: 5,
      };
      let getMoreJobResponse = await this.props.getMoreJobsOnScrollAction(
        payload
      );
      if (this.props.homebanner && this.props.homebanner.Data) {
        debugger;
        this.props.homebanner.Data.find((o, i) => {
          if (o.Position == 1) {
            this.setState({ homebanner1: o });
          }
          if (o.Position == 2) {
            this.setState({ homebanner2: o });
          }
        });
      }
      this.props.setLoader(false);
    } catch (error) {
      this.props.setLoader(false);
    }
  }
  addDefaultSrcPortfolio(ev) {
    ev.target.src = fullPageBanner2;
  }
  render() {
    // const home = (props) => {
    return (
      <div className="mt-80px  lg:pt-6 md:pt-6">
        <div className=" lg:px-2 md:px-2 px-5">
          <div className="slider mx-auto container">
            <SwipperBanner />
          </div>
        </div>

        {/* trending-jobs */}

        <div className="px-5 lg:px-0 md:px-0">
          <div className="trending-jobs container mx-auto">
            {/* <TrendingJobs /> */}
            <FeaturedJobs />
            <div className="flex justify-center mt-12">
              <Link to="/CareerApplicant/career/job-listing/">
                <button className="cust-viewall-btn flex">VIEW ALL</button>
              </Link>
            </div>
          </div>
        </div>

        {/* full banner */}
        <div className="mt-20 lg:mb-20 md:mb-20  container mx-auto">
          {/* <img src={fullPageBanner} className="w-full" alt="banner" /> */}
          {this.state.homebanner1 ? (
            <div className="relative">
              <img
                onError={this.addDefaultSrcPortfolio}
                src={
                  process.env.REACT_APP_IMAGE_BASE_MG +
                  this.state.homebanner1.path
                }
                className="w-full add-banner-c maxh-377px object-fill sm-h-150px"
                alt="banner"
              />
              <div className="insidetext-hiring">
                <h1 className="font-bold fsize36 text-white sm-fsize18">
                  {this.state.homebanner1.title}
                </h1>
                <hr className="hir-divider" />
                <div className="mt-6">
                  <button
                    className="viewall-btn-blue flex"
                    onClick={() =>
                      window.open(this.state.homebanner1.button_Url, "_blank")
                    }
                  >
                    {this.state.homebanner1.button_Text}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <img
                src={fullPageBanner}
                className="w-full add-banner-c"
                alt="banner"
              />
              <div className="insidetext-hiring">
                <h1 className="font-bold fsize36 text-white sm-fsize18">
                  ICICI Career
                </h1>
                <hr className="hir-divider" />
                <div className="lg:mt-12 md:mt-12  mt-4">
                  <button className="viewall-btn-blue flex">APPLY NOW</button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* browser category */}
        <div className="px-5 lg:px-0 md:px-0">
          <div className="trending-jobs container  mx-auto mt-8">
            <TabSlider />
            <div className="flex justify-center">
              <button className="cust-viewall-btn flex">VIEW ALL</button>
            </div>
          </div>
        </div>

        {/* programs offer */}
        <div className="lg:px-0 md:px-0 px-5">
          <div className="container mx-auto">
            <ProgramsOffer />
          </div>
        </div>

        {/* coursera */}
        <div className="px-5 lg:px-0 md:px-0">
          <div className="container mx-auto lg:mt-20 md:mt-20 mt-0" id="course">
            <CourseraCard />
            <div className="flex justify-center lg:mt-12 md:mt-12 mt-5">
              <Link to="/CareerApplicant/career/ilearn/">
                <button className="cust-viewall-btn flex">VIEW ALL</button>
              </Link>
            </div>
          </div>
        </div>

        {/* hring banner */}
        <div className="lg:my-28 md:my-28 my-12 relative container mx-auto">
          {this.state.homebanner2 ? (
            <div className="relative">
              <img
                onError={this.addDefaultSrcPortfolio}
                src={
                  process.env.REACT_APP_IMAGE_BASE_MG +
                  this.state.homebanner2.path
                }
                className="w-full add-banner-c maxh-377px object-fill   sm-h-150px"
                alt="banner"
              />
              <div className="insidetext-hiring">
                <h1 className="font-bold fsize36 text-white sm-fsize18">
                  {this.state.homebanner2.title}
                </h1>
                <hr className="hir-divider" />
                <div className="mt-6">
                  <button
                    className="viewall-btn-blue flex"
                    onClick={() =>
                      window.open(this.state.homebanner2.button_Url, "_blank")
                    }
                  >
                    {this.state.homebanner2.button_Text}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <img
                onError={fullPageBanner2}
                src={fullPageBanner2}
                className="w-full add-banner-c"
                alt="banner"
              />
              <div className="insidetext-hiring">
                <h1 className="font-bold fsize36 text-white sm-fsize18">
                  ICICI Career
                </h1>
                <hr className="hir-divider" />
                <div className="lg:mt-12 md:mt-12  mt-4">
                  <button className="viewall-btn-blue flex">APPLY NOW</button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* know us more  */}

        <div className="bg-f8f8f8 px-5 lg:px-0 md:px-0">
          <KnowUsMore />
        </div>

        <div className="lg:px-0 md:px-0 px-5">
          <div className="container mx-auto">
            <WhatsNews />
          </div>
        </div>

        {/* videoslider */}
        <div className="container mx-auto mb-12">
          {/* <VideoSlider /> */}
          <div className="flex justify-center mt-12">
            <Link to="/CareerApplicant/career/itv/">
              <button className="cust-viewall-btn flex">VIEW ALL</button>
            </Link>
          </div>
        </div>

        <div className="lg:px-0 md:px-0 px-5">
          <div className="trending-jobs container mx-auto pb-12">
            <FeaturedJobs />
            <div className="flex justify-center mt-12">
              <button className="cust-viewall-btn flex">VIEW ALL</button>
            </div>
          </div>
        </div>

        {/* employee story */}
        <div>
          <EmployeeStory />
        </div>

        {/* map section */}
        <div className="lg:mt-6 md:mt-6 mt-8 container mx-auto">
          <MapSection />
        </div>
        <div className="mt-6 footer-css">
          <FooterSection />
        </div>
        {/* <div className="chat-bot-logo">
          <img src={chatbot} alt="chatbot" />
        </div> */}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    billboard: state.Home.home.BILLBOARD,
    featuredjobs: state.Home.home.FEATUREDJOB,
    Auth: state.Auth.user,
    groups: state.Home.home.GROUPS,
    homebanner: state.Home.home.HOMEBANNER,
    checkitv: state.Home.home.CHECKITV,
    knowusemore: state.Home.home.KNOWUSMORE,
    getmorejobs: state.Home.home.GETMOREJOBS,

    // dashboard: state.dashboard.dashboard,
    // document: state.document.document,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getBillboardAction: async () => await dispatch(getBillboardAction()),
    getFeaturedJobAction: async () => await dispatch(getFeaturedJobAction()),
    groupsAction: () => dispatch(groupsAction()),

    getHomeBannerAction: async () => await dispatch(getHomeBannerAction()),
    getCheckITVAction: async () => await dispatch(getCheckITVAction()),
    getProgrammingAction: async () => await dispatch(getProgrammingAction()),
    getknowUsMoreAction: async () => await dispatch(getknowUsMoreAction()),
    getTeamiciciAction: async () => await dispatch(getTeamiciciAction()),
    getMoreJobsOnScrollAction: async (payload) =>
      await dispatch(getMoreJobsOnScrollAction(payload)),
    setLoader: async (flag) => await dispatch(setLoader(flag)),
    GetAllstories: async () => await dispatch(GetAllStoriesAction()),
    getAllCourses: async () => await dispatch(GetAllCourseAction()),
    getGroupRelatedJobIdAction: async (payload) =>
      await dispatch(getGroupRelatedJobIdAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(home);
// export default home;
